/**
 * Баннер «Продолжить расчёт «{name}»» — рендерится только когда есть незавершённый
 * draft-проект из калькулятора (Блок 12). Клик ведёт на соответствующий калькулятор
 * с этим draft.
 *
 * Phase 1 — visual placeholder. Реальный MSW handler `GET /api/calculator/projects?
 * status=draft` + Zod-схема `CalculatorDraftProject` — Phase 4 вместе с Calculator.
 *
 * Источник истины — прототип `screen-2-home.html` строки 423-435.
 * Контракт draft-объекта: `{ id, name, screen }`. `name` — название кухни/прихожей
 * (длинное, обрезается через CSS truncate). `screen` — целевой PRD-экран (например,
 * 2.12.2 для Кухни).
 */
export interface CalculatorDraft {
  id: string;
  name: string;
  screen: string;
}

export interface DraftBannerProps {
  draft: CalculatorDraft;
  onClick: (draft: CalculatorDraft) => void;
}

export function DraftBanner({ draft, onClick }: DraftBannerProps) {
  return (
    <button
      type="button"
      onClick={() => onClick(draft)}
      aria-label={`Продолжить расчёт ${draft.name}`}
      className={
        'w-full text-left bg-cta border-b-2 border-cta-shadow ' +
        'flex items-center justify-between gap-3 ' +
        'focus-visible:ring-2 focus-visible:ring-ink focus-visible:outline-none ' +
        'active:opacity-90 transition-opacity'
      }
      style={{ padding: '14px 16px' }}
    >
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-separator" style={{ fontSize: 14 }}>
          Продолжить расчёт
        </div>
        <div
          className="font-bold text-ink overflow-hidden whitespace-nowrap text-ellipsis"
          style={{ fontSize: 17 }}
        >
          «{draft.name}»
        </div>
      </div>
      <span aria-hidden="true" className="font-bold text-ink shrink-0" style={{ fontSize: 22 }}>
        →
      </span>
    </button>
  );
}
